export default [
  ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
  ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
  ['z', 'x', 'c', 'v', 'b', 'n', 'm'],
];



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/keyboard/layouts/LatinLayout.jsx